import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "windows",
  "use": "windows-usage",
  "viewBox": "0 0 124.216 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 124.216 128\" id=\"windows\"><path fill=\"#e0593c\" d=\"M0 0h58.174v60.195H0z\" /><path fill=\"#82b82c\" d=\"M66.042 0h58.174v60.195H66.042z\" /><path fill=\"#fab915\" d=\"M66.042 67.805h58.174V128H66.042z\" /><path fill=\"#349fda\" d=\"M0 67.805h58.174V128H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol